// import axios from "axios";

const getByZipCode = async (zipcode = "") => {
  try {
    const response = await fetch(`https://viacep.com.br/ws/${zipcode}/json`);
    return await response.json();
  } catch (error) {
    console.log(error);
  }
};

export { getByZipCode };
